import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectComponent } from './redirect.component';

const routes: Routes = [
  { path: 'redirect/:id', component: RedirectComponent }
];

@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { enableTracing: true ,useHash: true})],
  exports: [RouterModule],
})
export class RedirectRoutingModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/redirect/redirect-routing.module.ts